import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/lib/authClient';
import { Spinner } from '@/components/motion';

function ProtectedRoute({ children }) {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-center space-y-4">
          <Spinner className="h-10 w-10 mx-auto" />
          <p className="text-muted-foreground text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session?.user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
